import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M100 2C45.9 2 2 45.9 2 100s43.9 98 98 98 98-43.9 98-98-43.9-98-98-98zm-.9 47.1c14.7 0 26.7 12.1 26.7 26.9 0 14.8-12 26.9-26.7 26.9S72.4 90.8 72.4 76c-.1-14.8 11.9-26.9 26.7-26.9zm44.5 91.7c0 10-15.6 10-33.6 10H90.1c-18.8 0-33.6 0-33.6-10v-2c0-18.7 15.1-33.9 33.6-33.9H110c18.6 0 33.6 15.2 33.6 33.9v2z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}